import DownLoadButton from './DownLoadButton';
import Box from '@mui/material/Box';

const JobDetailExportButton = ({ onClick, buttonText, ...rest }) => (
  <Box sx={{ display: 'flex', justifyContent: 'flex-start', marginBottom: '12px' }}>
    <DownLoadButton
      buttonText={buttonText}
      onClick={onClick}
      sx={{
        width: '220px',
        fontSize: '14px',
      }}
      {...rest}
    />
  </Box>
);

export default JobDetailExportButton;
